import { useAppDispatch, useAppSelector } from 'hooks/store'
import { useSelector } from 'react-redux'
import {
  HasPlacedCourseOrderStatusType,
  getCasePlaceOrderUpdateFields,
  CourseOrderStep
} from 'share/domain/case'
import {
  setCasePlaceOrderUpdateFields,
  isDebtorType1
} from 'reducers/activecase/activecaseSlice'
import Button from 'react-bootstrap/Button'

function showRetryButton(currentStatus: number | undefined): boolean {
  if (
    currentStatus ===
    HasPlacedCourseOrderStatusType.ErrorMultipleOrdersFoundError
  ) {
    return false
  }

  if (
    currentStatus ===
    HasPlacedCourseOrderStatusType.ErrorOrderWithDifferentLastNameFoundError
  ) {
    return false
  }

  if (
    currentStatus === HasPlacedCourseOrderStatusType.ErrorMissingDudiUserError
  ) {
    return false
  }

  if (
    currentStatus ===
    HasPlacedCourseOrderStatusType.ErrorMissingOrganizationalUnitError
  ) {
    return false
  }

  return true
}

const CourseTabPlaceOrderError = (): JSX.Element => {
  const isDebtor1 = useSelector(isDebtorType1)
  const dispatch = useAppDispatch()
  const activeCase = useAppSelector((state) => state.activeCase)
  const courseData = useAppSelector((state) => state.activeCourse)

  function getHasPlacedFirstCourseOrderStatus(): number {
    let status: number
    if (isDebtor1) {
      status = activeCase.matter?.debtor1HasPlacedFirstCourseOrderStatus ?? 0
    } else {
      status = activeCase.matter?.debtor2HasPlacedFirstCourseOrderStatus ?? 0
    }
    return status
  }

  function getHasPlacedSecondCourseOrderStatus(): number {
    let status: number
    if (isDebtor1) {
      status = activeCase.matter?.debtor1HasPlacedSecondCourseOrderStatus ?? 0
    } else {
      status = activeCase.matter?.debtor2HasPlacedSecondCourseOrderStatus ?? 0
    }
    return status
  }

  const courseName = courseData?.activeTab === 'first' ? 'first' : 'second'
  const status =
    courseName == 'first'
      ? getHasPlacedFirstCourseOrderStatus()
      : getHasPlacedSecondCourseOrderStatus()

  const retryPlaceCourseOrder = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void => {
    e.preventDefault()

    const casePlaceOrderUpdateFields = getCasePlaceOrderUpdateFields(
      isDebtor1,
      courseData?.activeTab === 'first',
      HasPlacedCourseOrderStatusType.PlaceCourseOrderInProgress,
      CourseOrderStep.UserVerification
    )

    dispatch(setCasePlaceOrderUpdateFields(casePlaceOrderUpdateFields))
  }

  return (
    <div>
      {status ===
        HasPlacedCourseOrderStatusType.ErrorOnLookupStepUserVerification && (
        <div>
          An error occurred on the place {courseName} course order user
          verification step. Please try again in a few minutes. If this
          continues please contact your attorney for support in resolving this
          error.
        </div>
      )}

      {status === HasPlacedCourseOrderStatusType.ErrorOnCreateAccountStep && (
        <div>
          An error occurred on the place {courseName} course order account
          verification step. Please try again in a few minutes. If this
          continues please contact your attorney for support in resolving this
          error.
        </div>
      )}

      {status ===
        HasPlacedCourseOrderStatusType.ErrorOnAddSpouseorJointDebtorStep && (
        <div>
          An error occurred on the place {courseName} course order add spouse
          step. Please try again in a few minutes. If this continues please
          contact your attorney for support in resolving this error.
        </div>
      )}

      {status === HasPlacedCourseOrderStatusType.ErrorOnChooseCourseStep && (
        <div>
          An error occurred on the place {courseName} course order choose course
          step. Please try again in a few minutes. If this continues please
          contact your attorney for support in resolving this error.
        </div>
      )}

      {(status ===
        HasPlacedCourseOrderStatusType.ErrorOnPlaceAttorneyConsumerOrderStep ||
        status === HasPlacedCourseOrderStatusType.ErrorUnknown) && (
        <div>
          An error occurred while placing your {courseName} course order. Please
          try again in a few minutes. If this continues please contact your
          attorney for support in resolving this error.
        </div>
      )}

      {(status ===
        HasPlacedCourseOrderStatusType.ErrorMultipleOrdersFoundError ||
        status ===
          HasPlacedCourseOrderStatusType.ErrorMultipleOrdersFoundError ||
        status ===
          HasPlacedCourseOrderStatusType.ErrorOrderWithDifferentLastNameFoundError ||
        status === HasPlacedCourseOrderStatusType.ErrorMissingDudiUserError ||
        status ===
          HasPlacedCourseOrderStatusType.ErrorMissingOrganizationalUnitError) && (
        <div>
          An error occurred while placing your {courseName} course order. Please
          contact your attorney for support in resolving this error.
        </div>
      )}

      {showRetryButton(status) && (
        <div className='row'>
          <div className='col-sm-12 offset-md-3 offset-lg-2 col-md-6 col-lg-8 btn-container'>
            <Button
              data-testid='create-account-bookmark-goto-dashboard-button'
              type='button'
              className='btn btn-submit w-100 mt-3'
              onClick={retryPlaceCourseOrder}
            >
              Retry {courseName} order
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default CourseTabPlaceOrderError
